'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Container = undefined;

var _templateObject = _taggedTemplateLiteral(['\n    padding-top: 8px;\n    padding-bottom: 0px;\n    box-sizing: border-box;\n    ', '\n'], ['\n    padding-top: 8px;\n    padding-bottom: 0px;\n    box-sizing: border-box;\n    ', '\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactScroll = require('react-scroll');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Styled = _styledComponents2.default.div(_templateObject, function (_ref) {
    var styleString = _ref.styleString;
    return styleString;
});

var Container = exports.Container = function Container(_ref2) {
    var style = _ref2.style,
        children = _ref2.children,
        hasButtons = _ref2.hasButtons,
        pageNumber = _ref2.pageNumber;

    return _react2.default.createElement(
        Styled,
        { styleString: style, hasButtons: hasButtons },
        _react2.default.createElement(
            _reactScroll.Element,
            { name: 'page-' + pageNumber },
            children
        )
    );
};

Container.propTypes = {
    style: _propTypes2.default.string,
    pageNumber: _propTypes2.default.number,
    children: _propTypes2.default.node,
    hasButtons: _propTypes2.default.bool
};